/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S7_P3Inputs */

const en_guide_what_is_json_s7_p3 = /** @type {(inputs: Guide_What_Is_Json_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The format itself rarely changes, but the tooling around it keeps improving. Editors highlight it, browsers pretty print it in their dev tools, and databases now store and query it natively. Learning JSON well is one of those small investments that keeps paying off for years.`)
};

const ko_guide_what_is_json_s7_p3 = /** @type {(inputs: Guide_What_Is_Json_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`형식 자체는 거의 바뀌지 않지만 그 주변 도구는 계속 좋아집니다. 에디터가 강조 표시를 해주고, 브라우저 개발자 도구가 보기 좋게 정리해 주며, 데이터베이스는 이제 JSON을 그대로 저장하고 질의합니다. JSON을 제대로 익혀 두는 것은 오래도록 값을 돌려주는 작은 투자입니다.`)
};

const ja_guide_what_is_json_s7_p3 = /** @type {(inputs: Guide_What_Is_Json_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`形式そのものはめったに変わりませんが、その周辺のツールは進化し続けています。エディターがハイライトし、ブラウザの開発者ツールが見やすく整形し、データベースは今や JSON をそのまま保存して検索します。JSON をしっかり学ぶことは、何年も価値を返し続ける小さな投資です。`)
};

/**
* | output |
* | --- |
* | "The format itself rarely changes, but the tooling around it keeps improving. Editors highlight it, browsers pretty print it in their dev tools, and databases..." |
*
* @param {Guide_What_Is_Json_S7_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s7_p3 = /** @type {((inputs?: Guide_What_Is_Json_S7_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S7_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s7_p3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s7_p3(inputs)
	return ja_guide_what_is_json_s7_p3(inputs)
});